module.exports = __webpack_public_path__ + "static/media/8.abd95dc5.jpg";